$(document).on('turbolinks:load', function() {
  // 成績カレンダーページ以外では実行しない
  if (!window.Janreco.currentPath().match(/^\/point_calendars$/)) {
    return;
  }

  function normalizePlayType(value) {
    var n = parseInt(value, 10);
    return (n === 3 || n === 4) ? n : NaN;
  }

  function updateSwitchState(type) {
    var playTypeNum = normalizePlayType(type);
    var $toggleBtn = $('#play-type-toggle-switch');
    if ($toggleBtn.length === 0) { return; }

    var $fourOption = $toggleBtn.find('.js-toggle-4');
    var $threeOption = $toggleBtn.find('.js-toggle-3');

    $fourOption.toggleClass('active', playTypeNum === 4);
    $threeOption.toggleClass('active', playTypeNum === 3);
    $toggleBtn.toggleClass('three-active', playTypeNum === 3);
  }

  // 初期状態（URLパラメータから）
  (function initFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('play_type');

    var $toggleBtn = $('#play-type-toggle-switch');
    var dataDefault = parseInt($toggleBtn.data('default-type'), 10);
    var domDefault =
      ($toggleBtn.find('.js-toggle-3.active').length > 0) ? 3 :
      ($toggleBtn.find('.js-toggle-4.active').length > 0) ? 4 : NaN;

    var resolved =
      (raw != null && !isNaN(normalizePlayType(raw))) ? normalizePlayType(raw) :
      (!isNaN(dataDefault) && (dataDefault === 3 || dataDefault === 4)) ? dataDefault :
      (!isNaN(domDefault) && (domDefault === 3 || domDefault === 4)) ? domDefault :
      4; // 最終フォールバック

    updateSwitchState(resolved);
  })();

  // トグルクリック（AJAX送信はRails UJSに任せ、ここでは見た目だけ即時更新）
  $(document).on('click', '#play-type-toggle-switch .js-toggle-4, #play-type-toggle-switch .js-toggle-3', function() {
    var newType = $(this).hasClass('js-toggle-4') ? 4 : 3;
    updateSwitchState(newType);
  });
});